import React from 'react';

export class Toast extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pinned: new Set()
        };
    }

    static _lastMessageId = 0;

    static addToastToStateOf(component, message, propName = 'messages') {
        const newMessageId = ++this._lastMessageId;
        component.setState((prevState) => {
            const newMap = new Map(prevState[propName] || undefined);
            newMap.set(newMessageId, message);
            return {
                [propName]: newMap
            };
        });
    }

    static makeRemover(component, propName) {
        console.log('Making remover - if you see this frequently',
            'it is probably causing excessive renders,',
            'you need to make one remover and cache it in a class property');
        return function (id) {
            Toast.delMessage(component, id, propName);
        };
    }

    static delMessage(component, id, propName) {
        component.setState((prevState) => {
            const prevMap = prevState[propName];
            if (prevMap) {
                const newMap = new Map(prevMap);

                if (newMap.delete(id)) {
                    return {
                        [propName]: newMap
                    };
                }
            }

            return undefined;
        });
    }

    _expireTimers = new Map();

    /**
     *
     * @param {{messages: Map<number, Node>}} prevProps
     * @param {{}} prevState
     */
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.messages !== this.props.messages) {
            const added = new Map();
            const deleted = new Map(prevProps.messages);
            for (const [id, message] of this.props.messages) {
                // Not deleted if I saw it
                deleted.delete(id);

                // Added if it isn't in prev
                if (!prevProps.messages.has(id))
                    added.set(id, message);
            }

            for (const [id, _] of deleted)
                this._deleteMessageTimeout(id);

            for (const [id, message] of added)
                this._setMessageTimeout(message, id);
        }
    }

    _deleteMessageTimeout(id) {
        const expireTimeout = this._expireTimers.get(id);
        if (expireTimeout !== undefined) {
            clearTimeout(expireTimeout);
            this._expireTimers.delete(id);
        }
    }

    _setMessageTimeout(message, id) {
        const expireTimeout = setTimeout((id) => {
            if (this._mounted && this.props.onExpire)
                this.expireMessage(id);
        }, message.duration || this.props.defaultDuration || 5000,
            id);
        this._expireTimers.set(id, expireTimeout);
    }

    expireMessage(id) {
        this.props.onExpire(id);
    }

    componentDidMount() {
        this._mounted = true;
    }

    componentWillUnmount() {
        for (const timeout of this._expireTimers.values())
            clearTimeout(timeout);
        this._expireTimers.clear();
        this._mounted = false;
    }

    render() {
        return this.props.messages.size ?
            <div className="toast-container">
                {Array.from(this.props.messages.entries())
                    .reverse()
                    .map(([id, message]) => {
                        return <div key={id}
                            onPointerOver={(event) => {
                                this._deleteMessageTimeout(id);
                            }}
                            onPointerOut={(event) => {
                                if (!this.state.pinned.has(id))
                                    this._setMessageTimeout(message, id);
                            }}
                            onClick={(event) => {
                                this.togglePinned(id);
                            }}
                            className={"toast-wrapper" +
                                (message.kind === 'error'
                                    ? ' toast-error'
                                    : message.kind === 'warning'
                                        ? ' toast-warning'
                                        : message.kind === 'info'
                                            ? ' toast-info'
                                            : ' toast-error')}
                        >
                            {typeof message.content === 'function'
                                ? message.content()
                                : message.content}
                            <button className="toast-button" title="Copy"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    if (navigator && navigator.clipboard &&
                                        navigator.clipboard.writeText) {
                                        navigator.clipboard.writeText(message.text ||
                                            message.content)
                                            .then(() => {
                                                console.log('copied');
                                            });
                                    }
                                }}
                                children={'⧉'} />
                            <div className="noto top-right"
                                children={this.state.pinned.has(id)
                                    ? '📌'
                                    : ''} />
                        </div>;
                    })}
            </div>
            : null;
    }

    togglePinned(id) {
        this.setState((prevState) => {
            const updated = new Set(prevState.pinned);
            const was = updated.has(id);
            if (was)
                updated.delete(id);


            else
                updated.add(id);
            return {
                pinned: updated
            };
        });
    }
}
